<h4 id="headLine">Wie bist Du auf voilà! aufmerksam geworden?</h4>
<div class="row options basic-text">
  <div class="col-md-6">
    <markant-checkbox (checkedChange)="checkboxOtherStartupChanged($event, formNames.OTHERSTARTUP)" class="checkbox-with-sub-text"
      >Empfehlung durch anderes Start-up (bitte nennen)</markant-checkbox
    >
    <br />
    <div *ngIf="otherStartupTextVisible; then otherStartupInputField"></div>
    <markant-checkbox (checkedChange)="checkboxSimpleChanged($event, formNames.INSTAGRAM)" class="checkbox-simple">Instagram</markant-checkbox> <br />
    <markant-checkbox (checkedChange)="checkboxSimpleChanged($event, formNames.MARKANT)" class="checkbox-simple">Markant</markant-checkbox> <br />
    <markant-checkbox (checkedChange)="checkboxSimpleChanged($event, formNames.SEARCHENGINE)" class="checkbox-simple">Suchmaschine</markant-checkbox> <br />
  </div>
  <div class="col-md-6">
    <markant-checkbox (checkedChange)="checkboxRetailPartnerChanged($event, formNames.RETAILPARTNER)" class="checkbox-with-sub-boxes"
      >Empfehlung durch Händler (bitte nennen)</markant-checkbox
    >
    <br />
    <div *ngIf="retailPartnersVisible; then retailPartnersSubCheckboxes"></div>
    <markant-checkbox (checkedChange)="checkboxSimpleChanged($event, formNames.LINKEDIN)" class="checkbox-simple">LinkedIn</markant-checkbox> <br />
    <markant-checkbox (checkedChange)="checkboxOthersChanged($event, formNames.OTHERS)" class="checkbox-with-sub-text"
      >Sonstige (bitte nennen)</markant-checkbox
    >
    <br />
    <div *ngIf="othersTextVisible; then othersInputField"></div>
  </div>
</div>

<ng-template #otherStartupInputField>
  <div class="row sub-element">
    <div class="col-md-1"></div>
    <div class="col-md-10">
      <markant-input (valueChange)="textOtherStartupChanged($event)" class="text-input" placeholder="Bitte Startup nennen..."></markant-input>
    </div>
    <div class="col-md-1"></div>
  </div>
</ng-template>

<ng-template #retailPartnersSubCheckboxes>
  <div class="row sub-element">
    <div class="col-md-1"></div>
    <div class="col-md-5">
      <markant-checkbox (checkedChange)="retailPartnerDetailChanged($event, formNames.BARTELSLANGNESS)" class="checkbox-small"
        >Bartels-Langness GmbH & Co. KG</markant-checkbox
      >
      <markant-checkbox (checkedChange)="retailPartnerDetailChanged($event, formNames.DM)" class="checkbox-small"
        >dm-drogerie markt GmbH + Co. KG</markant-checkbox
      >
      <markant-checkbox (checkedChange)="retailPartnerDetailChanged($event, formNames.GLOBUS)" class="checkbox-small"
        >Globus SB-Warenhaus Holding GmbH & Co. KG</markant-checkbox
      >
      <markant-checkbox (checkedChange)="retailPartnerDetailChanged($event, formNames.MUELLER)" class="checkbox-small"
        >Müller Holding Ltd. & Co. KG</markant-checkbox
      >
    </div>
    <div class="col-md-5">
      <markant-checkbox (checkedChange)="retailPartnerDetailChanged($event, formNames.ROSSMANN)" class="checkbox-small">Dirk Rossmann GmbH</markant-checkbox>
      <markant-checkbox (checkedChange)="retailPartnerDetailChanged($event, formNames.KAES)" class="checkbox-small">Georg Jos. Kaes GmbH</markant-checkbox>
      <markant-checkbox (checkedChange)="retailPartnerDetailChanged($event, formNames.KAUFLAND)" class="checkbox-small"
        >Kaufland Dienstleistung GmbH & Co. KG</markant-checkbox
      >
    </div>
  </div>
</ng-template>

<ng-template #othersInputField>
  <div class="row sub-element">
    <div class="col-md-1"></div>
    <div class="col-md-10">
      <markant-input (valueChange)="textOthersChanged($event)" class="text-input" placeholder="Bitte nennen..."></markant-input> <br />
    </div>
    <div class="col-md-1"></div>
  </div>
</ng-template>
